import { basicPath } from '../basicPath';

export const fetchStudentAttendanceHistory = (params) => async (dispatch) => {
    const path = '/mp/student-attendance-history/student-id';
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}